import { defineAction } from '~/prix'
import { z } from 'zod'
import communityGardenMaterialUpdateAction from './communityGardenMaterialUpdate.action.json' with { type: 'json' }
import { communityGardenMaterialObject } from '../../communityGardenMaterialObject'

const communityGardenMaterialUpdateDefinition = defineAction({
  ...communityGardenMaterialUpdateAction,

  input: communityGardenMaterialObject.pick({ id: true, quantity: true }),
  output: z.object({}),
})

export default communityGardenMaterialUpdateDefinition
